import React from "react";
import { toggleSidebar } from "../../utils/sidebarToggle";

function AddInventoryHeader() {
  return (
    <div className="mainHead d-flex align-items-center justify-content-between pt-3 py-3">
      <div className="headText ms-3">Add Inventory</div>
      <div className="headIcons d-flex me-3">
        <div className="iconMain" id="sidebarToggle" onClick={toggleSidebar}>
          <i className="fa-solid fa-bars" />
        </div>
      </div>
    </div>
  );
}

export default AddInventoryHeader;
